module.exports = {"140404001":"韩店街道","140404101":"苏店镇","140404102":"荫城镇","140404103":"西火镇","140404104":"八义镇","140404106":"郝家庄镇","140404107":"南宋镇","140404201":"西池乡","140404202":"北呈乡","140404203":"东和乡","140404400":"振兴乡村生态文化旅游区","140404401":"上党经济技术开发区","140404406":"长治市经济技术开发区上党区部分"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140404.json
// module id = 379
// module chunks = 0